export default __webpack_public_path__ + "static/media/rec1.d381da4d.wav";